export const HOME = "/";
export const WORK = "/work";
export const SERVICES = "/services";
export const ABOUT = "/about";
export const PORTFOLIO = "/portfolio";
export const PROJECT = "/portfolio/:id";
export const CONTACT = "/contacts";
export const PRIVACY = "/privacy-policy";
